import { render } from "./BatchLoaderModalImages.vue?vue&type=template&id=1ba0b4eb&ts=true"
import script from "./BatchLoaderModalImages.vue?vue&type=script&lang=ts"
export * from "./BatchLoaderModalImages.vue?vue&type=script&lang=ts"

import "./BatchLoaderModalImages.vue?vue&type=style&index=0&id=1ba0b4eb&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__